/**
 * AGROMX Frontend - Persona Detalle View
 * Vista de detalle de una persona con todos sus datos
 */

import personaService from '../../services/persona.service.js';
import permisos from '../../services/permissions.service.js';
import router from '../../router/router.js';

export default {
  data: {
    persona: null,
    loading: true
  },

  async render(params) {
    const personaId = params?.id || window.location.pathname.match(/\/catalogos\/personas\/(\d+)/)?.[1];

    if (!personaId) {
      router.navigate('/catalogos/personas');
      return '<div>Error: ID no válido</div>';
    }

    try {
      this.data.persona = await personaService.getById(personaId);
      this.data.loading = false;
    } catch (error) {
      console.error('Error cargando persona:', error);
      window.toast.error('Error al cargar los datos');
      router.navigate('/catalogos/personas');
      return '<div>Error al cargar datos</div>';
    }

    const p = this.data.persona;

    return `
      <div class="page-header">
        <h1>Detalle de Persona</h1>
        <div style="display: flex; gap: 0.5rem;">
          <button class="btn btn-secondary" id="btnVolver">Volver</button>
        </div>
      </div>

      <!-- Información Principal -->
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Información Principal</h3>
          <span class="badge ${p.activo ? 'badge-success' : 'badge-secondary'}">
            ${p.activo ? 'Activo' : 'Inactivo'}
          </span>
        </div>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 1rem;">
          <div class="info-box">
            <div class="info-label">Código</div>
            <div class="info-value">${p.codigo || '-'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Tipo de Persona</div>
            <div class="info-value">
              <span class="badge ${p.tipo_persona === 'moral' ? 'badge-primary' : 'badge-info'}">
                ${p.tipo_persona === 'moral' ? 'Persona Moral' : 'Persona Física'}
              </span>
            </div>
          </div>
          <div class="info-box">
            <div class="info-label">Nombre / Razón Social</div>
            <div class="info-value">${p.nombre_completo}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Nombre Comercial</div>
            <div class="info-value">${p.nombre_comercial || '-'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">RFC</div>
            <div class="info-value">${p.rfc || '-'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Email</div>
            <div class="info-value">${p.email ? `<a href="mailto:${p.email}">${p.email}</a>` : '-'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Teléfono</div>
            <div class="info-value">${p.telefono || '-'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Celular</div>
            <div class="info-value">${p.celular || '-'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">WhatsApp</div>
            <div class="info-value">${p.whatsapp || '-'}</div>
          </div>
        </div>
      </div>

      <!-- Dirección -->
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Dirección</h3>
        </div>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem;">
          <div class="info-box" style="grid-column: span 2;">
            <div class="info-label">Dirección</div>
            <div class="info-value">${p.direccion || '-'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Colonia</div>
            <div class="info-value">${p.colonia || '-'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Ciudad</div>
            <div class="info-value">${p.ciudad || '-'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Estado</div>
            <div class="info-value">${p.estado || '-'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Código Postal</div>
            <div class="info-value">${p.codigo_postal || '-'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">País</div>
            <div class="info-value">${p.pais || 'México'}</div>
          </div>
        </div>
      </div>

      <!-- Detalles según tipo de persona -->
      ${this.renderDetallesTipo(p)}

      <!-- Roles -->
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Roles Asignados</h3>
        </div>
        ${this.renderRoles(p.roles)}
      </div>

      <!-- Contactos -->
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Contactos</h3>
          <button class="btn btn-sm btn-primary" id="btnAgregarContacto">+ Agregar</button>
        </div>
        ${this.renderContactos(p.contactos)}
      </div>

      <!-- Cuentas Bancarias -->
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Cuentas Bancarias</h3>
          <button class="btn btn-sm btn-primary" id="btnAgregarCuenta">+ Agregar</button>
        </div>
        ${this.renderCuentasBancarias(p.cuentas_bancarias)}
      </div>

      <!-- Notas -->
      ${p.notas ? `
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Notas</h3>
          </div>
          <p>${p.notas}</p>
        </div>
      ` : ''}

      <!-- Información de auditoría -->
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Información del Registro</h3>
        </div>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem;">
          <div class="info-box">
            <div class="info-label">Fecha de Creación</div>
            <div class="info-value">${personaService.formatDate(p.created_at)}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Última Actualización</div>
            <div class="info-value">${personaService.formatDate(p.updated_at)}</div>
          </div>
        </div>
      </div>

      <!-- Modal Agregar Contacto -->
      <div id="contactoModal" class="modal" style="display: none;">
        <div class="modal-content">
          <div class="modal-header">
            <h2>Agregar Contacto</h2>
            <button class="modal-close" id="btnCerrarContactoModal">&times;</button>
          </div>
          <form id="contactoForm">
            <div class="modal-body">
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label required">Nombre</label>
                  <input type="text" id="inputContactoNombre" class="form-control" required />
                </div>
                <div class="form-group">
                  <label class="form-label">Puesto</label>
                  <input type="text" id="inputContactoPuesto" class="form-control" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Email</label>
                  <input type="email" id="inputContactoEmail" class="form-control" />
                </div>
                <div class="form-group">
                  <label class="form-label">Teléfono</label>
                  <input type="tel" id="inputContactoTelefono" class="form-control" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Celular</label>
                  <input type="tel" id="inputContactoCelular" class="form-control" />
                </div>
                <div class="form-group">
                  <label>
                    <input type="checkbox" id="inputContactoPrincipal" />
                    Es contacto principal
                  </label>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" id="btnCancelarContacto">Cancelar</button>
              <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
          </form>
        </div>
      </div>

      <!-- Modal Agregar Cuenta Bancaria -->
      <div id="cuentaModal" class="modal" style="display: none;">
        <div class="modal-content">
          <div class="modal-header">
            <h2>Agregar Cuenta Bancaria</h2>
            <button class="modal-close" id="btnCerrarCuentaModal">&times;</button>
          </div>
          <form id="cuentaForm">
            <div class="modal-body">
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label required">Banco</label>
                  <input type="text" id="inputCuentaBanco" class="form-control" required />
                </div>
                <div class="form-group">
                  <label class="form-label">Tipo de Cuenta</label>
                  <select id="inputCuentaTipo" class="form-control">
                    <option value="cheques">Cheques</option>
                    <option value="ahorro">Ahorro</option>
                    <option value="inversion">Inversión</option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Número de Cuenta</label>
                  <input type="text" id="inputCuentaNumero" class="form-control" />
                </div>
                <div class="form-group">
                  <label class="form-label">CLABE (18 dígitos)</label>
                  <input type="text" id="inputCuentaClabe" class="form-control" maxlength="18" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Moneda</label>
                  <select id="inputCuentaMoneda" class="form-control">
                    <option value="MXN">MXN - Peso Mexicano</option>
                    <option value="USD">USD - Dólar Americano</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>
                    <input type="checkbox" id="inputCuentaPrincipal" />
                    Es cuenta principal
                  </label>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" id="btnCancelarCuenta">Cancelar</button>
              <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    `;
  },

  renderDetallesTipo(p) {
    if (p.tipo_persona === 'fisica' && p.detalles) {
      const d = p.detalles;
      return `
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Datos de Persona Física</h3>
          </div>
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem;">
            <div class="info-box">
              <div class="info-label">Nombre(s)</div>
              <div class="info-value">${d.nombre || '-'}</div>
            </div>
            <div class="info-box">
              <div class="info-label">Apellido Paterno</div>
              <div class="info-value">${d.apellido_paterno || '-'}</div>
            </div>
            <div class="info-box">
              <div class="info-label">Apellido Materno</div>
              <div class="info-value">${d.apellido_materno || '-'}</div>
            </div>
            <div class="info-box">
              <div class="info-label">CURP</div>
              <div class="info-value">${d.curp || '-'}</div>
            </div>
            <div class="info-box">
              <div class="info-label">Fecha de Nacimiento</div>
              <div class="info-value">${d.fecha_nacimiento ? personaService.formatDate(d.fecha_nacimiento) : '-'}</div>
            </div>
            <div class="info-box">
              <div class="info-label">Identificación</div>
              <div class="info-value">${d.tipo_identificacion || '-'} ${d.numero_identificacion ? `(${d.numero_identificacion})` : ''}</div>
            </div>
          </div>
        </div>
      `;
    }

    if (p.tipo_persona === 'moral' && p.detalles) {
      const d = p.detalles;
      return `
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Datos de Persona Moral</h3>
          </div>
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem;">
            <div class="info-box" style="grid-column: span 2;">
              <div class="info-label">Razón Social</div>
              <div class="info-value">${d.razon_social || '-'}</div>
            </div>
            <div class="info-box">
              <div class="info-label">Fecha de Constitución</div>
              <div class="info-value">${d.fecha_constitucion ? personaService.formatDate(d.fecha_constitucion) : '-'}</div>
            </div>
            <div class="info-box">
              <div class="info-label">Régimen Fiscal</div>
              <div class="info-value">${d.regimen_fiscal || '-'}</div>
            </div>
            <div class="info-box">
              <div class="info-label">Representante Legal</div>
              <div class="info-value">${d.representante_legal || '-'}</div>
            </div>
            <div class="info-box">
              <div class="info-label">Email Representante</div>
              <div class="info-value">${d.email_representante || '-'}</div>
            </div>
            <div class="info-box">
              <div class="info-label">Teléfono Representante</div>
              <div class="info-value">${d.telefono_representante || '-'}</div>
            </div>
          </div>
        </div>
      `;
    }

    return '';
  },

  renderRoles(roles) {
    if (!roles || roles.length === 0) {
      return '<p class="text-muted">No hay roles asignados</p>';
    }

    return `
      <div style="display: flex; flex-wrap: wrap; gap: 1rem;">
        ${roles.map(rol => {
          let configInfo = '';
          if (rol.configuracion_rol) {
            try {
              const config = typeof rol.configuracion_rol === 'string'
                ? JSON.parse(rol.configuracion_rol)
                : rol.configuracion_rol;

              if (config.puesto) configInfo += `<br>Puesto: ${config.puesto}`;
              if (config.area) configInfo += `<br>Área: ${config.area}`;
            } catch (e) { }
          }

          return `
            <div class="stat-card" style="flex: 0 0 auto; min-width: 200px;">
              <div class="stat-content">
                <span class="badge ${personaService.getRolBadgeClass(rol.rol)} ${!rol.activo ? 'badge-secondary' : ''}">
                  ${personaService.formatRol(rol.rol)}
                </span>
                ${!rol.activo ? '<span class="text-muted"> (Inactivo)</span>' : ''}
                ${configInfo ? `<div style="font-size: 0.85rem; margin-top: 0.5rem;">${configInfo}</div>` : ''}
              </div>
            </div>
          `;
        }).join('')}
      </div>
    `;
  },

  renderContactos(contactos) {
    if (!contactos || contactos.length === 0) {
      return '<p class="text-muted">No hay contactos registrados</p>';
    }

    return `
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Puesto</th>
              <th>Email</th>
              <th>Teléfono</th>
              <th>Principal</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            ${contactos.map(c => `
              <tr>
                <td><strong>${c.nombre}</strong></td>
                <td>${c.puesto || '-'}</td>
                <td>${c.email || '-'}</td>
                <td>${c.telefono || c.celular || '-'}</td>
                <td>${c.es_contacto_principal ? '<span class="badge badge-success">Sí</span>' : ''}</td>
                <td>
                  <button
                    class="btn-icon btn-danger"
                    onclick="personaDetalleView.eliminarContacto(${c.id})"
                    title="Eliminar"
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
  },

  renderCuentasBancarias(cuentas) {
    if (!cuentas || cuentas.length === 0) {
      return '<p class="text-muted">No hay cuentas bancarias registradas</p>';
    }

    return `
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>Banco</th>
              <th>Tipo</th>
              <th>Número de Cuenta</th>
              <th>CLABE</th>
              <th>Moneda</th>
              <th>Principal</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            ${cuentas.map(c => `
              <tr>
                <td><strong>${c.banco}</strong></td>
                <td>${c.tipo_cuenta}</td>
                <td>${c.numero_cuenta || '-'}</td>
                <td>${c.clabe || '-'}</td>
                <td>${c.moneda}</td>
                <td>${c.es_principal ? '<span class="badge badge-success">Sí</span>' : ''}</td>
                <td>
                  <button
                    class="btn-icon btn-danger"
                    onclick="personaDetalleView.eliminarCuenta(${c.id})"
                    title="Eliminar"
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
  },

  // Mapea el rol filtrado (URL) a la clave del módulo en el sistema de permisos
  _getModuloKey() {
    const urlParams = new URLSearchParams(window.location.search);
    const rol = urlParams.get('rol');
    const map = {
      cliente: 'clientes',
      responsable: 'responsables',
      distribuidor: 'distribuidores',
      agente_aduanal: 'agentes_aduanales'
    };
    return map[rol] || 'personas';
  },

  async afterRender() {
    const moduloKey = this._getModuloKey();
    if (!permisos.canView(moduloKey)) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.personaDetalleView = this;
    this.setupEventListeners();
  },

  setupEventListeners() {
    document.getElementById('btnVolver')?.addEventListener('click', () => {
      const urlParams = new URLSearchParams(window.location.search);
      const rol = urlParams.get('rol');
      const rolParam = rol ? `?rol=${rol}` : '';
      router.navigate(`/catalogos/personas${rolParam}`);
    });

    // Modal contacto
    document.getElementById('btnAgregarContacto')?.addEventListener('click', () => {
      document.getElementById('contactoModal').style.display = 'flex';
    });
    document.getElementById('btnCerrarContactoModal')?.addEventListener('click', () => {
      document.getElementById('contactoModal').style.display = 'none';
    });
    document.getElementById('btnCancelarContacto')?.addEventListener('click', () => {
      document.getElementById('contactoModal').style.display = 'none';
    });
    document.getElementById('contactoForm')?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.guardarContacto();
    });

    // Modal cuenta bancaria
    document.getElementById('btnAgregarCuenta')?.addEventListener('click', () => {
      document.getElementById('cuentaModal').style.display = 'flex';
    });
    document.getElementById('btnCerrarCuentaModal')?.addEventListener('click', () => {
      document.getElementById('cuentaModal').style.display = 'none';
    });
    document.getElementById('btnCancelarCuenta')?.addEventListener('click', () => {
      document.getElementById('cuentaModal').style.display = 'none';
    });
    document.getElementById('cuentaForm')?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.guardarCuenta();
    });

    // Cerrar modales al click fuera
    document.getElementById('contactoModal')?.addEventListener('click', (e) => {
      if (e.target.id === 'contactoModal') {
        document.getElementById('contactoModal').style.display = 'none';
      }
    });
    document.getElementById('cuentaModal')?.addEventListener('click', (e) => {
      if (e.target.id === 'cuentaModal') {
        document.getElementById('cuentaModal').style.display = 'none';
      }
    });
  },

  async guardarContacto() {
    try {
      const data = {
        nombre: document.getElementById('inputContactoNombre').value.trim(),
        puesto: document.getElementById('inputContactoPuesto').value.trim() || null,
        email: document.getElementById('inputContactoEmail').value.trim() || null,
        telefono: document.getElementById('inputContactoTelefono').value.trim() || null,
        celular: document.getElementById('inputContactoCelular').value.trim() || null,
        es_contacto_principal: document.getElementById('inputContactoPrincipal').checked ? 1 : 0
      };

      await personaService.agregarContacto(this.data.persona.id, data);
      window.toast.success('Contacto agregado exitosamente');
      document.getElementById('contactoModal').style.display = 'none';

      // Recargar vista
      location.reload();
    } catch (error) {
      window.toast.error(error.message || 'Error al agregar contacto');
    }
  },

  async guardarCuenta() {
    try {
      const data = {
        banco: document.getElementById('inputCuentaBanco').value.trim(),
        tipo_cuenta: document.getElementById('inputCuentaTipo').value,
        numero_cuenta: document.getElementById('inputCuentaNumero').value.trim() || null,
        clabe: document.getElementById('inputCuentaClabe').value.trim() || null,
        moneda: document.getElementById('inputCuentaMoneda').value,
        es_principal: document.getElementById('inputCuentaPrincipal').checked ? 1 : 0
      };

      await personaService.agregarCuentaBancaria(this.data.persona.id, data);
      window.toast.success('Cuenta bancaria agregada exitosamente');
      document.getElementById('cuentaModal').style.display = 'none';

      // Recargar vista
      location.reload();
    } catch (error) {
      window.toast.error(error.message || 'Error al agregar cuenta bancaria');
    }
  },

  async eliminarContacto(contactoId) {
    if (!confirm('¿Está seguro de eliminar este contacto?')) return;

    try {
      await personaService.eliminarContacto(this.data.persona.id, contactoId);
      window.toast.success('Contacto eliminado');
      location.reload();
    } catch (error) {
      window.toast.error(error.message || 'Error al eliminar contacto');
    }
  },

  async eliminarCuenta(cuentaId) {
    if (!confirm('¿Está seguro de eliminar esta cuenta bancaria?')) return;

    try {
      await personaService.eliminarCuentaBancaria(this.data.persona.id, cuentaId);
      window.toast.success('Cuenta bancaria eliminada');
      location.reload();
    } catch (error) {
      window.toast.error(error.message || 'Error al eliminar cuenta bancaria');
    }
  }
};
